import React from 'react';
import PropTypes from 'prop-types';
import SiteLogo from '../../misc/SiteLogo';
import configReader from '../../../config';
import { allowedLanguages } from '../../../languages';
import withLocalization from '../../higherOrderComponents/withLocalization';

const extraHeaderProps = {};
const { mode: environment } = configReader.get();
const isProduction = environment === 'production';
const isDevelopment = environment === 'development';

console.log(`Application running in ${environment} mode`)

const Header = () => (
  <header className='layout-page-header'>
    {isProduction ? null : (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: 0,
        textAlign: 'center',
        zIndex: 9999
      }}
      >
        <strong style={{
          display: 'inline-block',
          marginTop: '.17em',
          padding: '.5em',
          background: 'fuchsia',
          border: '1px solid gray',
          borderRadius: '3px',
          color: 'white'
        }}
        >
          {`${environment} mode`}
        </strong>
      </div>
    )}

    <section className={`site-header-bar-wrap ${isDevelopment ? 'development-mode' : ''}`}>
      <div className='site-header-bar content-width-limiter-wide' {...extraHeaderProps}>
        <div className='site-header-logo-wrap' style={{paddingTop:"5px", paddingLeft: "10px"}}>
          <SiteLogo adjustImages={false} />
        </div>
      </div>
    </section>
  </header>
);

Header.propTypes = {
  language: PropTypes.oneOf(allowedLanguages).isRequired,
  translate: PropTypes.func.isRequired,
  user: PropTypes.shape({
    Name: PropTypes.string.isRequired
  })
};

export default withLocalization(Header, 'layout/siteHeader');